import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'isomorphic-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { datadogRum } from '@datadog/browser-rum';
import {
	DATADOG_RUM_APPLICATION_ID,
	DATADOG_RUM_CLIENT_TOKEN,
	DATADOG_ENV,
	GITHUB_SHA,
} from 'src/utilities/envConfig';
import App from './App';
import { loadAlgoliaAnalytics, loadSegment } from './services/analytics';
import { basename } from './utilities/urlUtility';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { AuthProviderWrapper } from './components/Providers/AuthProviderWrapper';

loadSegment();
loadAlgoliaAnalytics();
datadogRum.init({
	allowedTracingUrls: [
		/https:\/\/catalog-appsync.*\.com\/graphql/,
		/https:\/\/catalog.guildacceptance\..*/,
		/https:\/\/catalog.guildeducation\..*/,
		/https:\/\/global-gql.*\.com\/graphql/,
	],
	applicationId: DATADOG_RUM_APPLICATION_ID,
	clientToken: DATADOG_RUM_CLIENT_TOKEN,
	env: DATADOG_ENV,
	service: 'catalog-frontend',
	sessionSampleRate: 100,
	site: 'datadoghq.com',
	trackFrustrations: true,
	trackUserInteractions: true,
	version: GITHUB_SHA,
});

ReactDOM.render(
	<ErrorBoundary>
		<AuthProviderWrapper>
			<BrowserRouter basename={basename}>
				<App />
			</BrowserRouter>
		</AuthProviderWrapper>
	</ErrorBoundary>,
	document.getElementById('root')
);
